/* globals ca */
//import { userInfo } from "os";

/*
 * Root Actions
 */
export default {
    initApp({ commit, state }) {
        // Add ca stuff to store so are not using globals everwhere
        if (typeof ca !== 'undefined' && ca !== null) {
            if (ca.hasOwnProperty('user') && typeof ca.user === 'object') {
                commit('setUser', ca.user);
            }

            if (ca.hasOwnProperty('client') && typeof ca.client === 'object') {
                commit('setClient', ca.client);
            }

            if (ca.hasOwnProperty('project') && typeof ca.project === 'object') {
                commit('setProject', ca.project);
            }

            if (ca.hasOwnProperty('breadcrumbs') && typeof ca.breadcrumbs === 'object') {
                commit('setBreadcrumbs', ca.breadcrumbs);
            }

            if (!!ca.api) {
                commit('setApiUrl', ca.api.url);

                if (!!ca.user && !!ca.user.token) {
                    commit('setApiToken', ca.user.token);
                    commit('setIsAuthenicated', true);
                }
            }
        }
    },
};
